import { render, staticRenderFns } from "./MyDocumentDetailsMobile.vue?vue&type=template&id=72b0b2dc&scoped=true&"
import script from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentDetailsMobile.vue?vue&type=style&index=0&id=72b0b2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0b2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b0b2dc')) {
      api.createRecord('72b0b2dc', component.options)
    } else {
      api.reload('72b0b2dc', component.options)
    }
    module.hot.accept("./MyDocumentDetailsMobile.vue?vue&type=template&id=72b0b2dc&scoped=true&", function () {
      api.rerender('72b0b2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyDocumentsMobile/MyDocumentDetailsMobile.vue"
export default component.exports